import { styled, css } from "styled-components";

import Button from "components/Button";
import { Wrapper, Container as GridContainer } from "style/components/Page";
import {
    BodyLAlt,
    styleLabelS,
    styleHeadingXL,
    styleHeadingL,
    styleBodyM,
} from "style/components/Typography";
import { columnGap, gap } from "style/grid";
import { MQ } from "style/mediaQueries";

export const StyledWrapper = styled(Wrapper).attrs<{
    $hasImage: boolean;
}>(() => ({}))`
    ${(props) =>
        !props.$hasImage &&
        css`
            margin-top: 4.375rem;

            ${MQ.FROM_M} {
                margin-top: 6.125rem;
            }

            ${MQ.FROM_XL} {
                margin-top: 7.875rem;
            }
        `}
`;

export const StyledContainer = styled(GridContainer)`
    ${gap};
    display: grid;
    grid-template-columns: repeat(4, [col-start] 1fr);

    ${MQ.FROM_XL} {
        grid-template-columns: repeat(12, [col-start] 1fr);
    }
`;

export const Heading = styled.h1`
    ${styleHeadingXL}
    margin-bottom: 0.4375rem;
    margin-top: 0;
`;

export const LoadMore = styled(Button)`
    grid-column: auto / span 4;
    margin-top: 6.5625rem;
    place-self: center center;

    ${MQ.FROM_M} {
        grid-column: auto / span 12;
    }

    ${MQ.FROM_XL} {
        margin-top: 5.25rem;
    }
`;

export const Author = styled.div`
    ${gap};
    display: grid;
    grid-column: col-start 1 / span 4;
    grid-template-columns: repeat(4, [col-start] 1fr);

    ${MQ.FROM_M} {
        grid-template-columns: repeat(4, [col-start] 1fr);
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 1 / span 12;
        grid-template-columns: repeat(12, [col-start] 1fr);
    }
`;

export const ProfileImage = styled.div`
    grid-column: col-start 1 / span 4;

    ${MQ.FROM_XL} {
        grid-column: col-start 1 / span 2;
    }
`;

export const ProfileInfo = styled.div.attrs<{
    $hasImage: boolean;
}>(() => ({}))`
    grid-column: col-start 1 / span 4;

    ${MQ.FROM_XL} {
        grid-column: col-start 3 / span 9;

        ${(props) =>
            !props.$hasImage &&
            css`
                grid-column: col-start 1 / span 9;
            `}
    }
`;

export const Role = styled.div`
    ${styleLabelS};
`;

export const ContactInfo = styled.div`
    ${styleBodyM};
    align-items: start;
    display: flex;
    flex-direction: column;
    grid-column: col-start 1 / span 4;
    margin-bottom: 1.75rem;

    ${MQ.FROM_M} {
        margin-bottom: 1.75rem;
    }

    ${MQ.FROM_L} {
        margin-bottom: 0;
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 1 / span 5;
    }
`;

export const LinkSection = styled.div`
    align-items: flex-start;
    display: flex;
    gap: 0.875rem;
    margin-bottom: 0.875rem;
`;

export const Introduction = styled(BodyLAlt)`
    grid-column: col-start 1 / span 4;

    ${MQ.FROM_M} {
        grid-column: col-start 2 / span 3;
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 7 / span 6;
    }
`;

export const NewsHeading = styled.h2`
    ${styleHeadingL}
    grid-column: auto / span 4;
    margin: 0;

    ${MQ.FROM_M} {
        grid-column: auto / span 6;
    }

    ${MQ.FROM_L} {
        grid-column: auto / span 4;
    }
`;

export const NewsItems = styled(GridContainer)`
    ${columnGap};
    display: grid;
    grid-template-columns: repeat(4, [col-start] 1fr);
    row-gap: 2.1875rem;

    ${MQ.FROM_M} {
        grid-template-columns: repeat(12, [col-start] 1fr);
    }

    ${MQ.FROM_XL} {
        row-gap: 3.5rem;
    }
`;

export const CardWrapper = styled.div`
    grid-column: auto / span 4;

    ${MQ.FROM_M} {
        grid-column: auto / span 6;
    }

    ${MQ.FROM_L} {
        grid-column: auto / span 4;
    }

    &:first-of-type {
        grid-column: 1 / span 4;

        ${MQ.FROM_M} {
            grid-column: 1 / span 6;
        }

        ${MQ.FROM_L} {
            grid-column: 1 / span 4;
        }
    }
`;
